import React from 'react';
import {userEntityDesc} from '../../../src/text/desc';
import {useUserEntitiesByEmail} from '../queries/options';

export const UserEntityInfo: React.FC<{email: null | undefined | string}> = ({email}) => {
  const {data: userEntitiesByEmail, isFetching} = useUserEntitiesByEmail();
  return userEntityDesc(email, userEntitiesByEmail);
};
